export default __webpack_public_path__ + "static/media/gbarbosa.03d2e35e.gif";